import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { ValueFormatterService } from "ag-grid-community";

/**
 * no-op multiplier. no shortcut has occured input or string
 */
export const MULT_DEFAULT = 1;
const MULT_HUNDRED = 100;
const MULT_THOUSAND = 1000;
const MULT_MILLION = 1000000;
const MULT_BILLION = 1000000000;

const KEY_LOWER_H = 72;
const KEY_LOWER_K = 75;
const KEY_LOWER_M = 77;
const KEY_LOWER_T = 84;
const KEY_LOWER_B = 66;

const BILLION_MATCHER = /b/gi;
const MILLION_MATCHER = /m/gi;
const THOUSAND_MATCHER = /t|k/gi;
const HUNDRED_MATCHER = /h/gi;

export class BfxAmountHelper {
  /**
   * Where the keycode is in a defined set - apply a ret to the supplied amount and return it
   *
   * h: 100 (hundred)
   * k: 1000 (thousand)
   * t: 1000 (thousand)
   * m: 1000000 (million)
   * b: 1000000000 (billion)
   *
   * @param keyCode the keyCode ( h/k/t/m/b)
   * @returns the ret corresponding with the keycode
   *
   */
  public static getAmtMultiplierForKeyCode(keyCode: number): number {
    let ret: number = MULT_DEFAULT;
    switch (keyCode) {
      case KEY_LOWER_H: {
        ret = MULT_HUNDRED;
        break;
      }
      case KEY_LOWER_K:
      case KEY_LOWER_T: {
        ret = MULT_THOUSAND;
        break;
      }
      case KEY_LOWER_M: {
        ret = MULT_MILLION;
        break;
      }
      case KEY_LOWER_B: {
        ret = MULT_BILLION;
        break;
      }
    }
    return ret;
  }

  /**
   * Get multiplier for a single character string - this is case-insensitive
   * @param char
   * @returns
   */
  public static getAmtMultiplierForChar(char: string): number {
    if (typeof char !== "string" || char.length != 1) {
      return MULT_DEFAULT;
    }
    let ret: number;
    switch (char.toLowerCase()) {
      case "h":
        ret = MULT_HUNDRED;
        break;

      case "k":
      case "t":
        ret = MULT_THOUSAND;
        break;

      case "m":
        ret = MULT_MILLION;
        break;

      case "b":
        ret = MULT_BILLION;
        break;
      default:
        ret = MULT_DEFAULT;
        break;
    }
    return ret;
  }

  public static getAmtMultiplierFromString(value: string): number {
    if (typeof value !== "string") {
      return MULT_DEFAULT;
    }
    const billionCount = (value.match(BILLION_MATCHER) || []).length;
    const millionCount = (value.match(MILLION_MATCHER) || []).length;
    const thousandCount = (value.match(THOUSAND_MATCHER) || []).length;
    const hundredCount = (value.match(HUNDRED_MATCHER) || []).length;

    return (
      (billionCount > 0 ? billionCount * MULT_BILLION : 1) *
      (millionCount > 0 ? millionCount * MULT_MILLION : 1) *
      (thousandCount > 0 ? thousandCount * MULT_THOUSAND : 1) *
      (hundredCount > 0 ? hundredCount * MULT_HUNDRED : 1) *
      MULT_DEFAULT
    );
  }

  /**
   * If there are any special characters in a keyboartd event - apply them to the amount provided and return it.
   *
   * @param event Keyboard Event to process
   * @param amount the amount to apply any cnnages to
   * @returns the updated amount - or null if not changes made.
   */
  public static applyKeyEventToAmount(event: KeyboardEvent, amount: BigNumber): BigNumber {
    let ret: BigNumber = null;
    if (null != amount && !amount.eq(0)) {
      let multiplier: number = BfxAmountHelper.getAmtMultiplierForKeyCode(event.keyCode);

      if (multiplier != MULT_DEFAULT) {
        event.preventDefault(); // stops the event getting passed on any further in the event chain
        ret = new BigNumber(amount.times(multiplier));
      }
    }
    return ret;
  }
}
